export default {
//	home: () => { import('./home'); }
}